import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { BellRinging, CheckCircle } from "@phosphor-icons/react";

export default function StockAlertForm({ productId, variant }) {
  const [email, setEmail] = useState("");
  const [hp, setHp] = useState("");
  const [busy, setBusy] = useState(false);
  const [doneFor, setDoneFor] = useState(null);
  const [err, setErr] = useState("");

  if (doneFor === variant.id) {
    return (
      <div data-testid="stock-alert-success" className="mt-3 flex items-center gap-2 text-sm text-[#2A4B3C] animate-in fade-in duration-300">
        <CheckCircle size={18} weight="fill" /> You're on the list. We'll email you once when it's back.
      </div>
    );
  }

  async function submit(e) {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await api.post("/stock-alerts", { product_id: productId, variant_id: variant.id, email: email.trim(), website: hp });
      setDoneFor(variant.id);
    } catch (e2) {
      setErr(formatApiError(e2));
    } finally {
      setBusy(false);
    }
  }

  return (
    <form onSubmit={submit} data-testid="stock-alert-form" className="mt-3">
      <div className="flex items-center gap-1.5 text-xs uppercase tracking-widest text-foreground/70 mb-2">
        <BellRinging size={14} weight="duotone" className="text-[#C84A31]" /> Email me when it's back
      </div>
      <div className="flex gap-2">
        <Input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@example.com"
          data-testid="stock-alert-email"
          className="h-10 rounded-sm bg-white flex-1"
        />
        <input type="text" tabIndex={-1} autoComplete="off" value={hp} onChange={(e) => setHp(e.target.value)} className="hidden" aria-hidden="true" name="website" />
        <Button type="submit" disabled={busy} data-testid="stock-alert-submit" className="btn-primary h-10 rounded-sm px-4">
          {busy ? "Saving…" : "Notify me"}
        </Button>
      </div>
      {err && <div data-testid="stock-alert-error" className="text-xs text-destructive mt-2">{err}</div>}
    </form>
  );
}
